// extracted by mini-css-extract-plugin
export default {"link":"CategoryCardsLine__link--slots-luoZ4","card":"CategoryCardsLine__card--slots-IH3FC"};